import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-copy",
  "use": "svg-copy-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\" id=\"svg-copy\"><path d=\"m16 16v4c0 1.1523-0.84772 2-2 2h-10c-1.1523 0-2-0.84772-2-2v-10c0-1.1523 0.84772-2 2-2h4v-4c0-1.1523 0.84772-2 2-2h10c1.1523 0 2 0.84772 2 2v10c0 1.1523-0.84772 2-2 2h-4zm-2 0h-4c-1.1523 0-2-0.84772-2-2v-4h-4v10h10v-4zm-4-12v10h10v-10h-10z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol